import { action, decorate, observable } from "mobx";
import get from "lodash/get";
import moment from "moment";
import {
    transferVoucher
} from "../services/VoucherService";

class VoucherStore {
    voucher = {};
    isLoading = false;
    formData = {};

    transferVoucher = async ({walletId}) => {
        const postData = {
            destination: {
                address:walletId,
                currency: "BTC"
            },
            voucher: {
                address: get(this.formData, "voucherId"),
                currency: "BTC",
                validUntil:  moment(get(this.formData, "date")).valueOf()
            }
        }

        const { data, error } = await transferVoucher(postData);
    
        
        if (data) {
            this.voucher = data;
            this.isLoading = false;
            return { data };
        } else {

            this.isLoading = false;
            return { error };
        }
    }
    setBarcode = (barcode) => {
        this.barcode = barcode;
    }
    setFormData = (data) => {
        this.formData = {...this.formData, ...data};
    }
    prepareDefaultValue = () => {
        this.formData = {};
        this.voucher = {};
    }
}

decorate(VoucherStore, {
    isLoading: observable,
    voucher: observable,
    formData: observable,
    transferVoucher: action,
    setBarcode: action,
    prepareDefaultValue: action,
    setFormData: action
});
export default new VoucherStore();
